export const Divider = ({ text }) => {
  return (
    <div className={`relative ${text ? 'my-3' : ''}`}>
      <div className="absolute inset-0 vertical-center" aria-hidden="true">
        <div className="w-full border-t border-surface-border" />
      </div>
      <div className="relative flex justify-center text-sm">
        {text ? (
          <span className="bg-white px-2 text-mediumgrey font-sans text-xs">{text}</span>
        ) : null}
      </div>
    </div>
  )
};

export const DateDivider = ({ label }) => (
    <div className="flex justify-center my-4">
      <span className="text-xs text-mediumgrey">{label}</span>
    </div>
  );
